"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderType = exports.OrderListPopup = void 0;
Object.defineProperty(exports, "showElement", {
  enumerable: true,
  get: function get() {
    return _showElement.showElement;
  }
});
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactSvg = require("react-svg");
var _List = require("./List");
var _context = require("../ConfigProvider/context");
var _getPrefixCls = require("../../utils/getPrefixCls");
var _FoodOrder = require("../FoodOrder");
var _Tabs = require("../Tabs");
var _constants = require("../../utils/constants");
var _LocaleProvider = require("../LocaleProvider");
var _Popup = require("../Popup");
var _FoodBuyerOrder = require("../FoodBuyerOrder");
var _useTracking = require("../../hooks/useTracking");
var _clsx3 = _interopRequireDefault(require("clsx"));
var _Button = require("../Button");
var _useServiceType = require("../FoodOrder/useServiceType");
var _showElement = require("./showElement");
var _food = _interopRequireDefault(require("../../assets/images/food.svg"));
var _spxInstant = _interopRequireDefault(require("../../assets/images/spx-instant.svg"));
var _spxInstantShopee = _interopRequireDefault(require("../../assets/images/spx-instant-shopee.svg"));
var _spxSameday = _interopRequireDefault(require("../../assets/images/spx-sameday.svg"));
var _foodServiceTypeColor, _serviceTypeLabelImag;
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var OrderType;
exports.OrderType = OrderType;
(function (OrderType) {
  OrderType["food"] = "food";
  OrderType["buyerFood"] = "buyerFood";
})(OrderType || (exports.OrderType = OrderType = {}));
var prefixCls = (0, _getPrefixCls.getPrefixCls)('order-list-popup');
var foodServiceTypeColor = (_foodServiceTypeColor = {}, (0, _defineProperty2.default)(_foodServiceTypeColor, _useServiceType.FoodOrderServiceType.Food, '#F69113'), (0, _defineProperty2.default)(_foodServiceTypeColor, _useServiceType.FoodOrderServiceType.SPXInstant, '#26AA99'), (0, _defineProperty2.default)(_foodServiceTypeColor, _useServiceType.FoodOrderServiceType.SPXInstantShopee, '#0046AB'), (0, _defineProperty2.default)(_foodServiceTypeColor, _useServiceType.FoodOrderServiceType.SPXSameDayShopee, '#EE2C4A'), _foodServiceTypeColor);
var serviceTypeLabelImage = (_serviceTypeLabelImag = {}, (0, _defineProperty2.default)(_serviceTypeLabelImag, _useServiceType.FoodOrderServiceType.Food, /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
  src: _food.default
})), (0, _defineProperty2.default)(_serviceTypeLabelImag, _useServiceType.FoodOrderServiceType.SPXInstant, /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
  src: _spxInstant.default
})), (0, _defineProperty2.default)(_serviceTypeLabelImag, _useServiceType.FoodOrderServiceType.SPXInstantShopee, /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
  src: _spxInstantShopee.default
})), (0, _defineProperty2.default)(_serviceTypeLabelImag, _useServiceType.FoodOrderServiceType.SPXSameDayShopee, /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
  src: _spxSameday.default
})), _serviceTypeLabelImag);
var OrderListPopup = function OrderListPopup(props) {
  var _renderOrderMap;
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans;
  var onLoadMore = props.onLoadMore,
    onSelectOrder = props.onSelectOrder,
    componentTrackingData = props.componentTrackingData,
    showLoading = props.showLoading,
    panelTitleText = props.panelTitleText,
    _props$groupOrderText = props.groupOrderText,
    groupOrderText = _props$groupOrderText === void 0 ? trans(_constants.GROUP_ORDER_TEXT) || 'Group Order' : _props$groupOrderText,
    onClosePopup = props.onClosePopup,
    loadMoreParams = props.loadMoreParams,
    limit = props.limit,
    _props$orderCardType = props.orderCardType,
    orderCardType = _props$orderCardType === void 0 ? OrderType.food : _props$orderCardType,
    listWrapperStyle = props.listWrapperStyle,
    orderCardStyle = props.orderCardStyle,
    active = props.active,
    container = props.container,
    showTabs = props.showTabs,
    _props$tabs = props.tabs,
    tabs = _props$tabs === void 0 ? [] : _props$tabs,
    selectOrderText = props.selectOrderText,
    isUIOptimisation = props.isUIOptimisation;
  var context = (0, _react.useContext)(_context.ConfigContext);
  var _useState = (0, _react.useState)(Date.now()),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    showTime = _useState2[0],
    setShowTime = _useState2[1];
  var _useComponentTracking = (0, _useTracking.useComponentTracking)({
      componentTrackingData: componentTrackingData,
      componentData: _objectSpread({}, props)
    }),
    tracker = _useComponentTracking.tracker,
    closePanelTrackingData = _useComponentTracking.result.closePanel;
  var handleCloseTracking = function handleCloseTracking() {
    var _closePanelTrackingDa;
    var trackingData = _objectSpread(_objectSpread({}, (closePanelTrackingData === null || closePanelTrackingData === void 0 ? void 0 : (_closePanelTrackingDa = closePanelTrackingData.trackingClick) === null || _closePanelTrackingDa === void 0 ? void 0 : _closePanelTrackingDa.data) || {}), {}, {
      view_duration: Math.floor((Date.now() - showTime) / 1000)
    });
    (closePanelTrackingData === null || closePanelTrackingData === void 0 ? void 0 : closePanelTrackingData.trackingClick) && tracker.click(_objectSpread(_objectSpread({}, closePanelTrackingData === null || closePanelTrackingData === void 0 ? void 0 : closePanelTrackingData.trackingClick), {}, {
      data: trackingData
    }));
  };
  (0, _react.useEffect)(function () {
    if (active) {
      // popup弹出时重新设置 开始展示的时间
      setShowTime(Date.now());
    }
  }, [active]);
  var handleClosePopup = function handleClosePopup() {
    handleCloseTracking();
    onClosePopup === null || onClosePopup === void 0 ? void 0 : onClosePopup();
  };
  var handleSelectOrder = function handleSelectOrder(order) {
    handleCloseTracking();
    onSelectOrder === null || onSelectOrder === void 0 ? void 0 : onSelectOrder(order);
  };
  var onClickDriverOrder = function onClickDriverOrder(order) {
    var _context$eventEmitter, _context$eventEmitter2;
    var action = order.action,
      orderId = order.orderId;
    action && (context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : (_context$eventEmitter2 = _context$eventEmitter.emit) === null || _context$eventEmitter2 === void 0 ? void 0 : _context$eventEmitter2.call(_context$eventEmitter, action === null || action === void 0 ? void 0 : action.func, {
      text: orderId === null || orderId === void 0 ? void 0 : orderId.toString(),
      action: action
    }, action.callback));
    handleSelectOrder(order);
  };
  var renderFoodOrder = (0, _react.useCallback)(function (item, index) {
    var _item$groupOrders$0$s, _item$groupOrders, _item$groupOrders$, _item$groupOrders3;
    var serviceType = (_item$groupOrders$0$s = (_item$groupOrders = item.groupOrders) === null || _item$groupOrders === void 0 ? void 0 : (_item$groupOrders$ = _item$groupOrders[0]) === null || _item$groupOrders$ === void 0 ? void 0 : _item$groupOrders$.serviceType) !== null && _item$groupOrders$0$s !== void 0 ? _item$groupOrders$0$s : _useServiceType.FoodOrderServiceType.Food;
    if (isUIOptimisation) {
      var _item$groupOrders2;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "-order-ui-optimisation-wrapper")
      }, (_item$groupOrders2 = item.groupOrders) !== null && _item$groupOrders2 !== void 0 && _item$groupOrders2.length ? /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "-ui-optimisation-group-order-wrapper"),
        style: {
          border: "1px solid ".concat(foodServiceTypeColor[serviceType])
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "-ui-optimisation-group-order-wrapper-header"),
        style: {
          background: "".concat(foodServiceTypeColor[serviceType])
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "-ui-optimisation-group-order-wrapper-service-type")
      }, serviceTypeLabelImage[serviceType], trans(_useServiceType.ServiceTypeLabelKeyMap[serviceType])), groupOrderText && /*#__PURE__*/_react.default.createElement("div", null, groupOrderText)), item.groupOrders.map(function (order) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: order.orderId,
          className: "".concat(prefixCls, "-order-ui-optimisation-group-order")
        }, /*#__PURE__*/_react.default.createElement(_FoodOrder.FoodOrder, (0, _extends2.default)({}, order, {
          index: index,
          key: order.orderId,
          onClick: function onClick() {
            return onClickDriverOrder(order);
          },
          componentTrackingData: componentTrackingData,
          wrapperStyle: _objectSpread(_objectSpread({}, orderCardStyle), {}, {
            background: '#FFFFFF',
            margin: 0
          }),
          isUIOptimisation: isUIOptimisation
        })), /*#__PURE__*/_react.default.createElement(_Button.Button, {
          type: "primary-outlined",
          className: "".concat(prefixCls, "-order-ui-optimisation-button"),
          onClick: function onClick() {
            return onClickDriverOrder(order);
          }
        }, trans('Select')));
      })) : /*#__PURE__*/_react.default.createElement("div", {
        key: item.orderId,
        className: "".concat(prefixCls, "-order-ui-optimisation")
      }, /*#__PURE__*/_react.default.createElement(_FoodOrder.FoodOrder, (0, _extends2.default)({}, item, {
        index: index,
        componentTrackingData: componentTrackingData,
        wrapperStyle: _objectSpread(_objectSpread({}, orderCardStyle), {}, {
          background: '#FFFFFF',
          margin: 0
        }),
        isUIOptimisation: isUIOptimisation
      })), /*#__PURE__*/_react.default.createElement(_Button.Button, {
        type: "primary-outlined",
        className: "".concat(prefixCls, "-order-ui-optimisation-button"),
        onClick: function onClick() {
          return onClickDriverOrder(item);
        }
      }, trans('Select'))));
    }
    if ((_item$groupOrders3 = item.groupOrders) !== null && _item$groupOrders3 !== void 0 && _item$groupOrders3.length) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "-group-order-wrapper")
      }, groupOrderText && /*#__PURE__*/_react.default.createElement("p", {
        className: "".concat(prefixCls, "-banner")
      }, groupOrderText), item.groupOrders.map(function (order) {
        return /*#__PURE__*/_react.default.createElement(_FoodOrder.FoodOrder, (0, _extends2.default)({}, order, {
          index: index,
          key: order.orderId,
          onClick: function onClick() {
            return onClickDriverOrder(order);
          },
          componentTrackingData: componentTrackingData,
          wrapperStyle: orderCardStyle
        }));
      }));
    }
    return /*#__PURE__*/_react.default.createElement(_FoodOrder.FoodOrder, (0, _extends2.default)({}, item, {
      index: index,
      key: item.orderId,
      onClick: function onClick() {
        return onClickDriverOrder(item);
      },
      componentTrackingData: componentTrackingData,
      wrapperStyle: orderCardStyle
    }));
  }, [props, closePanelTrackingData]);
  var renderFoodBuyerOrder = (0, _react.useCallback)(function (item, index, tab) {
    return /*#__PURE__*/_react.default.createElement(_FoodBuyerOrder.FoodBuyerOrder, (0, _extends2.default)({}, item, {
      index: index,
      tab: tab,
      selectOrderText: selectOrderText,
      onSelectOrder: function onSelectOrder() {
        return handleSelectOrder(item);
      },
      componentTrackingData: componentTrackingData
    }));
  }, [props, closePanelTrackingData]);
  var renderOrderMap = (_renderOrderMap = {}, (0, _defineProperty2.default)(_renderOrderMap, OrderType.food, renderFoodOrder), (0, _defineProperty2.default)(_renderOrderMap, OrderType.buyerFood, renderFoodBuyerOrder), _renderOrderMap);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Popup.Popup, {
    title: panelTitleText || trans(_constants.BUYER_ORDER_LIST_TITLE_TEXT),
    showCloseIcon: true,
    active: active,
    onClose: function onClose() {
      return handleClosePopup();
    },
    titleClassName: "".concat(prefixCls, "-title"),
    contentClassName: "".concat(prefixCls, "-content"),
    container: container
  }, showTabs ? /*#__PURE__*/_react.default.createElement(_Tabs.Tabs, {
    titles: tabs,
    className: "".concat(prefixCls, "-tabs-content-class"),
    componentTrackingData: componentTrackingData,
    titleClass: "".concat(prefixCls, "-tabs-title-class"),
    type: _Tabs.Type.underscore
  }, tabs.map(function (tab) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx3.default)("".concat(prefixCls, "-list-wrapper"), (0, _defineProperty2.default)({}, "".concat(prefixCls, "-list-wrapper-ui-optimisation"), isUIOptimisation)),
      style: listWrapperStyle,
      key: tab.name
    }, /*#__PURE__*/_react.default.createElement(_List.OrderList, {
      limit: limit,
      loadMoreParams: loadMoreParams,
      showLoading: showLoading,
      onLoadMore: onLoadMore,
      renderOrder: renderOrderMap[orderCardType],
      componentTrackingData: componentTrackingData,
      tab: tab
    }));
  })) : /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx3.default)("".concat(prefixCls, "-list-wrapper"), (0, _defineProperty2.default)({}, "".concat(prefixCls, "-list-wrapper-ui-optimisation"), isUIOptimisation)),
    style: listWrapperStyle
  }, /*#__PURE__*/_react.default.createElement(_List.OrderList, {
    limit: limit,
    loadMoreParams: loadMoreParams,
    showLoading: showLoading,
    onLoadMore: onLoadMore,
    componentTrackingData: componentTrackingData,
    renderOrder: renderOrderMap[orderCardType]
  }))));
};
exports.OrderListPopup = OrderListPopup;